import React, { useEffect } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    HStack,
    Box,
    Text,
    Spacer,
    Stack,
    Flex,
    Image,

} from '@chakra-ui/react'
import SraList from './SraList'
import moment from 'moment/moment'
import { GrAttachment } from 'react-icons/gr'
import { BsArrowDownCircleFill, BsArrowUpCircleFill, BsFillCloudUploadFill } from 'react-icons/bs'
import Input from './Input'
import { useState } from 'react'
import Button from './Button'
import { UploadInvoice, UploadWaybillFile } from '../Utils/ApiCalls'
import { local } from '../Utils/ApiConfig'



export default function AttachmentModal({ isOpen, onClose, singleData }) {

    console.log("singleData", singleData)


    const [Loading, setLoading] = useState(false);
    const [Image, setImage] = useState(null);
    const [WayBill, setWayBill] = useState(false);
    const [invoice, setinvoice] = useState(false);

    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });

    const handleWaybill = (e) => {

        let file = e.target.files[0]
        setImage(file)
        setWayBill(true)
        setinvoice(false)


    }
    const handleInvoice = (e) => {

        let file = e.target.files[0]
        setImage(file)
        setinvoice(true)
        setWayBill(false)


    }

    const uploadInvoice = async () => {

        const formData = new FormData();

        formData.append("file", Image);


        console.log("formData", formData.get("file"))

        try {


            setLoading(true)

            let result = await UploadInvoice(formData, singleData[0]?._id);

            console.log("resultWaybill", result);

            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Invoice Uploaded successfully"
                })

                setImage(null)



                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            console.error('Error:', e.message);
        }

    }
    const uploadWaybill = async () => {

        const formData = new FormData();

        formData.append("file", Image);


        console.log("formData", formData.get("file"))

        try {


            setLoading(true)

            let result = await UploadWaybillFile(formData, singleData[0]?._id);

            console.log("resultWaybill", result);

            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Waybill Uploaded successfully"
                })

                setImage(null)


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            console.error('Error:', e.message);
        }

    }
    const [OpenImg, setOpenImg] = useState(false);

    const toggle = () => {
        setOpenImg(!OpenImg)
    }

    useEffect(() => {
        setOpenImg(false)
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>SRA Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"20px"}>
               
                        <HStack borderBottom={"1px solid grey"} pb="10px">
                            <Text fontWeight={"800"}>Attachment</Text>
                            <Box onClick={toggle} fontSize="18px" color="teal">
                                {
                                    OpenImg ? <BsArrowDownCircleFill /> : <BsArrowUpCircleFill />
                                }
                            </Box>


                        </HStack>

                        <Flex justifyContent={"space-between"}>


                            {
                                OpenImg === true && (
                                    <Box>

                                        <Text textAlign="left" fontWeight={"500"}>Waybill Image</Text>
                                        {
                                            singleData[0]?.sra.waybillimageurl  ? (
                                                <Box display={"flex"} justifyContent="center">


                                                    <br />
                                                    <a target={"blank"} href={`${local}/api/v1/uploads/${singleData[0]?.sra.waybillimageurl}`}>

                                                        <img class="img" src={`${local}/api/v1/uploads/${singleData[0]?.sra.waybillimageurl}`} alt="waybill" />
                                                    </a>
                                                </Box>
                                            ) : (
                                                <Text textAlign="left" fontWeight={"500"}>Not found</Text>

                                            )
                                        }


                                    </Box>
                                )
                            }


                            {
                                OpenImg === true && (
                                    <Box >

                                        <Text textAlign="left" fontWeight={"500"}>IIR Image</Text>
                                        {
                                            singleData[0]?.sra.invoiceimageurl  ? (
                                                <Box display={"flex"} justifyContent="center">                                            <br />
                                                    <a target={"blank"} href={`${local}/api/v1/uploads/${singleData[0]?.sra.invoiceimageurl}`}>

                                                        <img class="img" src={`${local}/api/v1/uploads/${singleData[0]?.sra.invoiceimageurl}`} alt="waybill" />
                                                    </a>

                                                </Box>
                                            ) : (
                                                <Text textAlign="left" fontWeight={"500"}>Not found</Text>

                                            )
                                        }


                                    </Box>
                                )
                            }



                        </Flex>

                    </Stack>

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
